export default __webpack_public_path__ + "static/media/Cars_15.7331e45e.png";